import CheckInOutTimes from "../../components/Check-in Check-out/checkin checkout times";
import Gallery from "../../components/gallery/gallery";
import InfoList from "../../components/info links/info links";
import AmenitiesCard from "../../components/Page-3/AmenitiesCard";
import Policies from "../../components/Page-3/Policies";
import PropertyAmenities from "../../components/Page-3/PropertyAmenities";
import RoomDetails from "../../components/Page-3/RoomDetails";
import ReviewRating from "../../components/review rating/review rating";
import ProgressBarReview from "../../components/Page-3/Reviews/progressbar-chart";
import ReviewCard from "../../components/Page-3/Reviews/Review-card";
import ReviewMain from "../../components/Page-3/Reviews/Review-main";
import SimilarProperties from "../../components/Page-3/Similar Properties/similar";
import CheckoutDetails from "./../../components/Page-3/CheckoutDetails";
import PropertyLocation from "./../../components/Page-3/PropertyLocation";
import MealOptions from "./../../components/Page-3/MealOptions";
import FAQ from "../../components/Page-3/FAQ";
import PublicQuestions from "../../components/Page-3/PublicQuestions";
import Footer from "../../components/Footer/Footer.main";
import HeaderMain from "../../components/Header-Final/HeaderMain";
import Input from "../../components/Input/Input-main";
import { animateScroll as scroll, scroller } from "react-scroll";
import Header2 from "../../components/Header-2/Header2-main";
import { useLocation } from "react-router-dom";
import { useState,useRef  } from "react";
import axios from "axios";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Audio, Bars, Blocks, ColorRing } from "react-loader-spinner";
import { useParams } from "react-router-dom";
import { FiShare2 } from "react-icons/fi";
import ClipboardJS from 'clipboard';
const aboutUs =
  " Lodged amidst landscaped verdure, extensive gardens and sumptuous amenities, The Charcoal Villa is the definition of modern, laidback luxury. Sweeping you to a secluded sanctuary, this opulent abode isquite literally a refuge from the chaos and buzz of urban clamour. This generously proportioned villa is imbued with exquisite taste, evident in the abundance eometric designs, the soothing monochromes and the curated bold choice of furnishings. The ash-black facade mirrors its name, whilst its interiors consistently echo hints of the charcoal palette. The radiant indoor spaces glow under the plentiful sunlight and seamlessly open up to the sprawling outdoors.Lodged amidst landscaped verdure, extensive gardens and sumptuous amenities, The Charcoal Villa is the definition of modern, laidback luxury. Sweeping you to a secluded sanctuary, this opulent abode is quite literally a refuge from the chaos and buzz of urban clamour. This generously proportioned villa is imbued with exquisite taste, evident in the abundance of geometric designs, the soothing monochromes and the curated bold choice of furnishings. The ash-black facade mirrors its name, whilst its interiors consistently echo hints of the charcoal palette. The radiant indoor spaces glow under the plentiful sunlight and seamlessly open up to the sprawling outdoors";

const policies = [
  "The full payment must be made for your booking to be confirmed,",
  "The number of guests must not exceed the count mentioned at the time of booking.",
  "The property reserves the right to deny check-in if the number of people exceeds the maximum capacity of the villa. If check-in is allowed, additional charges may apply as per the property.",
  "Only the guests who have been accounted for are allowed at the villa.",
  "All guests must be able to share valid ID proofs when asked. This could be at the time of booking, and also upon arrival.",
  "All foreign nationals must be able to share their passport and visa details prior to their stay.",
  " Any damage to the property caused by the guest will be charged as per the actual cost of repair or replacement.",
  "Any illegal activity - including but not limited to prostitution and the use of narcotics - is strictly not permitted.",
  "Any commercial activity is strictly not permitted.",
];

const houseRules = [
  "The property is located in a secluded area",
  "This home is not suitable for wheelchair users and guests with mobility challenges.",
  "In case of a power outage, the generator can support the ACs and refrigerator for up to 24 hours",
  "There is also an inverter that can support all lights and fans for up to 5 hours.",
  "The road leading up to the villa may not be concrete.",
  "The caretaker’s pet dog resides on the property premises for security purposes.",
  "There are CCTV cameras that capture the external areas of the villa for security purposes.",
  "The rooms are in the form of separate cottages. These cottages are connected via a common patio.",
];

const questions = [
  {
    question: "Does the room have AC?",
    answer: "Yes yes sure",
    date: "14 July 2021",
  },
  {
    question: "Is it the entire villa?",
    answer: "Yes it is entirely yours",
    date: "14 July 2021",
  },
  {
    question: "Are the photos taken recently?",
    answer: "Yes it is taken recently",
    date: "14 July 2021",
  },
];

const foodData = {
  points: [true, 3200, true, true],
  images: [
    {
      src: "https://plus.unsplash.com/premium_photo-1671117129890-ad9c09af995a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1025&q=80",
    },
    {
      src: "https://plus.unsplash.com/premium_photo-1671117129890-ad9c09af995a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1025&q=80",
    },
    {
      src: "https://plus.unsplash.com/premium_photo-1671117129890-ad9c09af995a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1025&q=80",
    },
    {
      src: "https://plus.unsplash.com/premium_photo-1671117129890-ad9c09af995a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1025&q=80",
    },
  ],
};

const data = [
  { rating: "Outstanding : 9+", numReviews: 100 },
  { rating: "Excellent : 7-9", numReviews: 75 },
  { rating: "Good : 5-7", numReviews: 50 },
  { rating: "Passable : Below 5", numReviews: 25 },
];
const items = [
  {
    title: "Item 1",
    description: "Description for item 1",
  },
  {
    title: "Item 2",
    description: "Description for item 2",
  },
  {
    title: "Item 3",
    description: "Description for item 3",
  },
];
const comments = [
  {
    name: "John Doe",
    rating: 8,
    comment: "This is a great component!",
  },
  {
    name: "Jane Doe",
    rating: 10,
    comment: "I love this component!",
  },
  {
    name: "Bob Smith",
    rating: 5,
    comment: "This component needs more work.",
  },
];
const dummyData = {
  name: "Abhishek Bachchan",
  stayDuration: "Stayed 3 nights in deluxe suite",
  rating: 10,
  date: "12 March, 2021",
  comment:
    "This villa is very nice although the location is bad but don't judge their villa by location",
  photos: [
    {
      src: "https://plus.unsplash.com/premium_photo-1671117129890-ad9c09af995a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1025&q=80",
    },
    {
      src: "https://plus.unsplash.com/premium_photo-1671129471248-82d1ba9dab31?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1107&q=80",
    },
    {
      src: "https://images.unsplash.com/photo-1678063464239-16b19ce80eac?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1161&q=80",
    },
    {
      src: "https://images.unsplash.com/photo-1677610757680-f95bd51e64e9?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1026&q=80",
    },
    // ...
  ],
};

const villaNavItems = [
  "Amenties",
  "Layout",
  "Location Nearby",
  "Food",
  "Rules & Policies",
  "Reviews",
  "FAQs",
  "Similar Villas",
];
const locationDetails = {
  nearby: [
    "Ryewood Park 6km",
    "Shivaji Garden 6km",
    "Raywood Garden 6km",
    "Diwali Baug 6km",
    "Lion's Point 10km",
    "Tiger Point 10km",
    "Restaurant Sheetal Da Dhaba 500m",
    "Restaurant NH4 Food Plaza 2.6km",
    "Restaurant Mangan Lal 600m",
    "Malavli 2.4km",
    "Train Lonavla Railway station 5km",
    "Pune International Airport 26km",
    "Chhatrapati Shivaji International Airport Mumbai 53km",
  ],
  latitude: "26.449",
  longitude: "74.66",
};

const DetailedVilla = () => {
  const scrollToSection = (section) => {
    const element = document.getElementById(section);
    if (element) {
      //  Will scroll smoothly to the top of the next section
      element.scrollIntoView({
        behavior: "smooth",
        block: "center",
        // inline: "nearest",
      });
    }
  };
  const { villaId: urlVillaId } = useParams();
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const Location = useLocation();
  const formData = Location.state;
  const linkRef = useRef(null)
  const [location, setLocation] = useState(
    formData?.location ? formData.location : ""
  );
  const [adults, setAdults] = useState(formData?.adults ? formData.adults : 2);
  const [children, setChildren] = useState(
    formData?.children ? formData.children : 0
  );
  const [startDate, setStartDate] = useState(
    formData?.startDate ? formData.startDate : ""
  );
  const [endDate, setEndDate] = useState(
    formData?.endDate ? formData.endDate : ""
  );

  const [villaData, setVillaData] = useState(null);
  const [totalPrice, setTotalPrice] = useState();
  const [availability, setAvailability] = useState(true);

  // //console.log(startDate, endDate, "DATES");
  // //console.log(villaData, "SJKDBKVDSHKSDVKSHVD");
  const handleSearch = async () => {
    const searchVillaId = formData?.villaId ? formData.villaId : urlVillaId;

    if (searchVillaId) {
      const res = await axios.get(
        `http://localhost:8000/api/v1/getvillabyid?property_id=${searchVillaId}`
      );

      setVillaData(res.data.data[0]);
    }
  };

  useEffect(() => {
    handleSearch();
  }, []);

  useEffect(() => {
    if (villaData && startDate && endDate) {
      let priceSum = 0;
      let flag = true;

      for (
        let d = new Date(startDate);
        d < endDate;
        d.setDate(d.getDate() + 1)
      ) {
        let tempDate = d.toISOString().slice(0, 10);
        if (villaData.availability_per_date[tempDate] === 0) flag = false;
        priceSum += parseInt(villaData.price_per_date[tempDate]);
      }
      setTotalPrice(priceSum);
      if (!priceSum || priceSum === 0) flag = false;
      setAvailability(flag);
      //console.log(priceSum, "Total wala");
    }
  }, [villaData, startDate, endDate]);

  const handleInputSearch = () => {
    const formData = {
      location: location,
      startDate: startDate,
      endDate: endDate,
      adults: adults,
      children: children,
    };
    const hyphenlocation = location.replace(' ', '-');
    navigate(`/search/${hyphenlocation}`, { state: formData });
  };
  const handleShareClick = () => {
    // Copy the sharable link and message to the clipboard
    const link = `${window.location.origin}/villa/${villaData.property_ptr_id}/${villaData.property_name.replace(/\s+/g, '-')}`;

    const clipboard = new ClipboardJS(linkRef.current, {
      text: () => link,
    });

    clipboard.on('success', () => {
      // Show the modal popup when the link is copied
      setShowModal(true);
      clipboard.destroy();
    });

    clipboard.on('error', (err) => {
      console.error('Could not copy text: ', err);
      clipboard.destroy();
    });
  };
  return (
    <>
      {villaData ? (
        <div className="font-hk justify-center ">
          {showModal && (
            <div className="fixed inset-0 flex items-center justify-center z-50">
              <div className="absolute inset-0 bg-black opacity-50"></div>
              <div className="bg-white p-6 rounded font-hk shadow-lg relative z-10 flex flex-col items-center">
                <p className="text-lg mb-4">Sharable link copied!</p>
                <button
                  className="px-6 py-2 bg-black text-white rounded-full mt-auto transition-all hover:scale-[1.05]"
                  onClick={() => setShowModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          )}

          {/* <HeaderMain /> */}
          <div className="sticky top-0 z-[3000]">
            <Header2
              location={location}
              setLocation={setLocation}
              setAdults={setAdults}
              adults={adults}
              children={children}
              setChildren={setChildren}
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              handleInputSearch={handleInputSearch}
            />
          </div>

          {/* <Input /> */}
          <div className="flex flex-row justify-between font-sans mt-6 mx-auto w-[90vw]">
            <div>
              <div className="flex flex-row">
                <div className="mb-2 mr-2 font-bold text-[50px] text-black hover:cursor-pointer hover:underline">
                  {villaData.property_name}
                </div>
                <button
                  className="ml-5 transition-all hover:scale-[1.4] focus:outline-none" ref={linkRef}
                  onClick={handleShareClick}
                >
                  <FiShare2 size={32} />
                </button>
              </div>

              <div className="flex flex-row mb-4">
                <svg
                  width="25"
                  height="25"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_133_311)">
                    <path
                      d="M15.9961 14.8652L14.7391 7.93984C14.7266 7.87071 14.6837 7.81084 14.6223 7.77668L11.4585 6.01699C11.4174 5.99411 11.3714 5.98502 11.3262 5.98852L11.9018 13.4138L11.8825 13.4224L15.6689 15.1211C15.6997 15.1349 15.7324 15.1417 15.765 15.1417C15.8166 15.1417 15.8677 15.1247 15.9098 15.0918C15.9785 15.0382 16.0117 14.9509 15.9961 14.8652Z"
                      fill="#44C868"
                    />
                    <path
                      d="M7.99997 7.69923L4.76418 6.01389C4.7254 5.99367 4.6824 5.98542 4.64005 5.98826C4.65127 5.98757 4.66255 5.98764 4.67374 5.98851L4.09814 13.4138L7.90381 15.1211C7.93453 15.1348 7.96731 15.1417 7.99997 15.1417V7.69923Z"
                      fill="#44C868"
                    />
                    <path
                      d="M4.67376 5.98855C4.62854 5.98505 4.58251 5.99415 4.54144 6.01699L1.37759 7.77668C1.31615 7.81084 1.27328 7.87068 1.26075 7.93984L0.00377743 14.8652C-0.0117851 14.9509 0.021465 15.0381 0.0901213 15.0918C0.132215 15.1247 0.183309 15.1417 0.234872 15.1417C0.267465 15.1417 0.300247 15.1349 0.331028 15.1211L4.09679 13.4317L4.67376 5.98855Z"
                      fill="#4CE166"
                    />
                    <path
                      d="M11.3262 5.98839C11.2951 5.9908 11.2643 5.99908 11.2358 6.01395L8 7.69927V15.1417C8 15.1417 8 15.1417 8.00003 15.1417C8.03269 15.1417 8.0655 15.1349 8.09619 15.1211L11.9019 13.4138L11.3262 5.98839Z"
                      fill="#4CE166"
                    />
                    <path
                      d="M0.879856 10.0386L0.624512 11.4454L4.40558 9.44833L4.49336 8.31586L4.50792 8.12805L0.879856 10.0386Z"
                      fill="#FFDB56"
                    />
                    <path
                      d="M4.43957 9.0092L4.40554 9.44833L0.624466 11.4454L0.00377743 14.8652C-0.0117851 14.9509 0.021465 15.0381 0.0901213 15.0918C0.132215 15.1247 0.183309 15.1417 0.234872 15.1417C0.267465 15.1417 0.300247 15.1349 0.331028 15.1211L4.09679 13.4317L4.43957 9.0092Z"
                      fill="#A8EEFC"
                    />
                    <path
                      d="M8.00118 8.62752L4.50811 8.12805L4.40576 9.44833L8.00024 14.9071V12.9221L5.85533 9.54467L8.00118 9.80133V8.62752Z"
                      fill="#FFBB24"
                    />
                    <path
                      d="M14.3737 7.63817L12.8539 6.79282L11.415 7.12901L11.433 7.36139L11.5041 8.27808L14.3737 7.63817Z"
                      fill="#FFBB24"
                    />
                    <path
                      d="M11.6314 9.92428L11.4951 8.1665L11.4147 7.12903L8.00098 8.62753V9.80134L10.2309 8.83165L11.6314 9.92428Z"
                      fill="#FFDB56"
                    />
                    <path
                      d="M15.9964 14.8652L15.6807 13.1256L11.5039 8.27808L11.6315 9.92427L15.915 15.0874C15.9801 15.0335 16.0116 14.9487 15.9964 14.8652Z"
                      fill="#FFBB24"
                    />
                    <path
                      d="M8.01499 0.858278C6.20364 0.858278 4.72998 2.33072 4.72998 4.1406C4.72998 5.26016 5.26151 6.46217 6.30986 7.71317C7.07983 8.63201 7.83933 9.22298 7.8713 9.2477C7.91361 9.28042 7.9643 9.29677 8.01502 9.29677C8.06571 9.29677 8.11642 9.28042 8.15874 9.2477C8.19067 9.22298 8.95021 8.63201 9.72018 7.71317C10.7685 6.46217 11.3001 5.26019 11.3001 4.1406C11.3 2.33072 9.82633 0.858278 8.01499 0.858278ZM9.23155 4.14057C9.23155 4.81188 8.68686 5.35613 8.01499 5.35613C7.34311 5.35613 6.79842 4.81191 6.79842 4.14057C6.79842 3.46922 7.34311 2.925 8.01499 2.925C8.68686 2.925 9.23155 3.46925 9.23155 4.14057Z"
                      fill="#FF4A4A"
                    />
                    <path
                      d="M8.01503 0.858278C7.87147 0.858278 7.73006 0.867591 7.59131 0.885528C9.20328 1.09387 10.4526 2.47416 10.4526 4.1406C10.4526 5.26016 9.92109 6.46217 8.87275 7.71317C8.37759 8.30405 7.88712 8.75901 7.59134 9.01533C7.75553 9.15758 7.85997 9.23889 7.87134 9.2477C7.91365 9.28042 7.96434 9.29677 8.01506 9.29677C8.06575 9.29677 8.11647 9.28042 8.15878 9.2477C8.19072 9.22298 8.95025 8.63201 9.72022 7.71317C10.7686 6.46217 11.3001 5.26019 11.3001 4.1406C11.3 2.33072 9.82637 0.858278 8.01503 0.858278Z"
                      fill="#E7343F"
                    />
                    <path
                      d="M8.09619 15.1211L9.51135 14.4862L8 12.9221V15.1417C8 15.1417 8 15.1417 8.00003 15.1417C8.03269 15.1417 8.06547 15.1349 8.09619 15.1211Z"
                      fill="#FFDB56"
                    />
                    <path
                      d="M14.7394 7.93983C14.7269 7.87071 14.684 7.81083 14.6226 7.77667L14.3735 7.63814L11.5039 8.27805L15.6807 13.1256L14.7394 7.93983Z"
                      fill="#1EA4E9"
                    />
                    <path
                      d="M7.99999 15.1417C8.00002 15.1417 8.00002 15.1417 7.99999 15.1417V14.9071L4.40555 9.44833L4.09814 13.4138L7.90381 15.1211C7.93453 15.1349 7.96731 15.1417 7.99999 15.1417Z"
                      fill="#1EA4E9"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_133_311">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <div className="ml-2 text-[16px]">{villaData.area}</div>
              </div>
            </div>
            <div>
              <a href="#!" className="text-gray-900 ml-auto -mt-3 -mr-2">
                <div className="flex flex-row space-x-2 ">
                  <div className="">
                    <h1 className=" text-[#F31F1F] font-medium text-[25px] ">
                      Marvellous
                    </h1>
                    <h2 className="text-black text-[20px] font-semibold">
                      {villaData.review_count} reviews
                    </h2>
                    {/* <i className="far fa-heart text-red-500 fa-lg" /> */}
                  </div>
                  <div className=" my-auto">
                    <span className="bg-black text-white p-2 pb-2 text-center rounded-lg text-[20px] ">
                      {villaData.a2z_score === null
                        ? "N/A"
                        : villaData.a2z_score}
                      {/* {villadata.a2z_score} */}
                    </span>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div className="flex justify-center font-sans mt-6">
            <nav className="mt-5  w-[90vw] flex justify-center">
              <ul className="flex mx-auto w-full">
                {villaNavItems.map((villaNavItem) => (
                  <div className="py-2 w-[13%] px-2 mr-[16px] flex items-center bg-[#f1f1f1]  shadow-md border-[1px]  rounded-t-lg font-semibold text-[15px] hover:cursor-pointer">
                    <li className="w-full">
                      <a
                        onClick={() => {
                          scrollToSection(villaNavItem);
                        }}
                      >
                        <div className="text-center">{villaNavItem}</div>
                      </a>
                    </li>
                  </div>
                ))}
              </ul>
            </nav>
          </div>

          <section id="Amenities">
            <div className="font-bold text-[22px] mt-10 mb-4 ml-20 underline">
              Amenities
            </div>
          </section>
          <div className="flex justify-center font-sans mt-6 mb-6">
            <div className="p-4 w-[90vw] bg-[#f1f1f1]  border-[1px] rounded-lg shadow-lg flex flex-row ">
              <div className="flex flex-col w-2/3">
                <Gallery
                  galleryData={villaData.media}
                  media_order={villaData.media_order}
                />
              </div>
              <div className="mt-5 ml-20 w-1/3">
                <PropertyAmenities free={villaData.amenities} />
              </div>
            </div>
          </div>

          <section id="Layout">
            <div className="font-bold text-[22px] mt-10 mb-4 ml-20 underline">
              Layout
            </div>
          </section>
          <CheckoutDetails
            adultsCount={villaData.number_of_adults}
            childrenCount={villaData.number_of_children}
            bedrooms={villaData.number_of_bedrooms}
            price={
              totalPrice && totalPrice !== 0
                ? totalPrice
                : villaData.price_guest_pay
            }
            price_per_extra_person={villaData.price_per_extra_person}
            tax={villaData.is_tax_included}
            breakfast={villaData.is_breakfast}
            lunch={villaData.is_lunch}
            dinner={villaData.is_dinner}
            area={villaData.size_of_property}
            adults={adults}
            setAdults={setAdults}
            children={children}
            setChildren={setChildren}
            startDate={startDate}
            endDate={endDate}
            villaData={villaData}
            availability={availability}
          />

          <section id="Location Nearby">
            <div className="font-bold text-[22px] mt-10 mb-4 ml-20 underline">
              Nearby Locations
            </div>
          </section>
          <div className="container flex justify-center font-sans mt-6 mb-12">
            <div className="p-6 w-[90vw] bg-[#f1f1f1]  border-[1px] rounded-lg shadow-lg flex flex-row relatvie z-1">
              <PropertyLocation
                latitude={villaData.geo_lat}
                longitude={villaData.geo_long}
                nearby={villaData.whats_nearby}
              />
            </div>
          </div>

          <section id="Food">
            <div className="font-bold text-[22px] mt-10 mb-4 ml-20 underline">
              Food Options
            </div>
          </section>
          <MealOptions
            foodData={foodData}
            meal_package_non_veg_adult_price={
              villaData.meal_package_non_veg_adult_price
            }
            meal_package_non_veg_child_price={
              villaData.meal_package_non_veg_child_price
            }
            meal_package_veg_adult_price={
              villaData.meal_package_veg_adult_price
            }
            meal_package_veg_child_price={
              villaData.meal_package_veg_child_price
            }
          />

          <section id="Rules & Policies">
            <div className="font-bold text-[22px] mt-10 mb-4 ml-20 underline">
              Rules & Policies
            </div>
          </section>
          <Policies
            policies={policies}
            aboutUs={aboutUs}
            houseRules={houseRules}
          />

          <section id="Reviews">
            <div className="font-bold text-[22px] mt-10 mb-4 ml-20 underline">
              Reviews
            </div>
          </section>
          <ReviewMain />

          <section id="FAQs">
            <div className="font-bold text-[22px] mt-10 mb-4 ml-20 underline">
              FAQs
            </div>
          </section>
          <FAQ data={villaData.property_name} />
          <PublicQuestions questions={questions} />

          {villaData.landmark[0] && (
            <>
              <section id="Similar Villas">
                <div className="font-bold text-[22px] mt-10 mb-4 ml-20 underline">
                  Similar Villas
                </div>
              </section>
              <SimilarProperties
                data={villaData.landmark[0].villas_with_same_landmark}
                landmark={villaData.landmark[0].landmark?.title}
                location={location}
                adults={adults}
                children={children}
                startDate={startDate}
                endDate={endDate}
              />
            </>
          )}
          <Footer />
        </div>
      ) : (
        <div class="flex justify-center items-center h-screen">
          <div class="flex flex-col justify-evenly my-auto mx-auto">
            <ColorRing
              visible={true}
              height="150"
              width="150"
              ariaLabel="blocks-loading"
              wrapperStyle={{}}
              wrapperClass="blocks-wrapper"
              colors={["#e15b64", "#f47e60", "#f8b26a", "#abbd81", "#849b87"]}
            />
            <div className="text-center text-[25px] font-hk">Please Wait</div>
          </div>
        </div>
      )}
    </>
  );
};

export default DetailedVilla;
